module.exports = __webpack_public_path__ + "static/media/get-connected.e4ee8f53.svg";